import * as React from 'react';
import { LegendEntry } from 'components/LegendEntry';
import { Colors } from './colors';
import { HatchPatternId, getHatchPatternFill } from './Patterns';

interface Props {
  showHistoric?: boolean;
}

export const Legend: React.FC<Props> = (props) => {
  const { showHistoric } = props;
  return (
    <div className="flex items-center space-x-8">
      <LegendEntry fill={Colors.NonDisputable} label="Non disputable per diem" />
      <LegendEntry fill={Colors.Disputable} label="Disputable per diem" />
      {showHistoric && (
        <>
          <LegendEntry
            fill={getHatchPatternFill(HatchPatternId.NonDisputable)}
            label="Non disputable per diem - past"
          />
          <LegendEntry
            fill={getHatchPatternFill(HatchPatternId.Disputable)}
            label="Disputable per diem - past"
          />
        </>
      )}
    </div>
  );
};
Legend.displayName = 'Shipments.Historical.Legend';
